import React, { useState } from 'react';
import { Stack } from '@mui/material';
import { StyledTabs, StyledTab, TabContainer } from './CredentialUsage.styles';
import { useCredentialUsage } from './useCredentialUsage';
import { CredentialUsageItem } from '../CredentialUsageItem/CredentialUsageItem';
import { CredentialUsageItemSkeletonList } from '../CredentialUsageItem/CredentialUsageItemSkeleton';
import { EmptyState } from 'new/elements/EmptyState';

interface CredentialUsageProps {
  credentialId?: number;
}

const TABS = [
  {
    value: 'sources',
    label: 'Sources',
  },
  {
    value: 'destinations',
    label: 'Destinations',
  },
];

export const CredentialUsage: React.FC<CredentialUsageProps> = ({ credentialId }) => {
  const { loading, error, data } = useCredentialUsage(credentialId);
  const [activeTab, setActiveTab] = useState(TABS[0]?.value || 'overview');

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue);
  };

  const dataList = data && activeTab === 'sources' ? data?.data_sources : data?.data_sinks;

  const content =
    Array.isArray(dataList) && dataList.length > 0 ? (
      dataList?.map((item: any) => <CredentialUsageItem key={item.id} item={item} />)
    ) : (
      <EmptyState
        title="No usage found"
        description={`The credential has not been used in any ${activeTab}.`}
      />
    );

  return (
    <Stack direction="column">
      <TabContainer>
        <StyledTabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          {TABS.map((tab) => (
            <StyledTab
              key={tab.value}
              value={tab.value}
              label={tab.label}
              data-testid={`credential-tab-${tab.value}`}
            />
          ))}
        </StyledTabs>
      </TabContainer>

      {loading && <CredentialUsageItemSkeletonList />}

      <Stack direction="column" padding="16px" gap="12px">
        {error && <div>Error: {error.message}</div>}
        {!loading && !error && content}
      </Stack>
    </Stack>
  );
};

CredentialUsage.displayName = 'CredentialUsage';
